export const unitFaq = {
  head: {
    title: "Unit questions & answers",
    chip: "AI",
    subPre: "Answers specific to",
    subStrong: "this unit",
    subPost: ". The agent will use them first when helping a guest staying here (e.g. their door code, quirks of this apartment…). Attach images or videos and the agent will send them whenever the guest needs them.",
  },
  clone: {
    titleNoun: "FAQs",
    itemNoun: "the FAQs",
    buttonLabel: "Clone questions",
  },

  copyOne: {
    title: "Copy this question",
    itemNoun: "question",
  },
  loading: "Loading…",
  emptyList: "No questions yet. Add the first one so the agent knows how to answer it.",
  list: {
    newQuestion: "New question",
    attachments: "{count} attachment | {count} attachments",
    learnedTitle: "Added by self-learning",
    deleteTitle: "Delete",
    copyTitle: "Copy to other units",
  },
  form: {
    questionLabel: "Question",
    answerLabel: "Agent's answer",
    qPlaceholder: "Question · e.g. What's the door code?",
    aPlaceholder: "Answer · e.g. Your building's entrance code is 4512.",
    removeAttachment: "Remove attachment",
    uploading: "Uploading…",
    attach: "Attach",
    addQuestion: "Add question",
  },
  preview: {
    tag: "Preview · WhatsApp",
    online: "online",
    aiReception: "AI reception",
    questionPlaceholder: "Type the guest's question…",
    answerPlaceholder: "Type the answer the agent will give…",
    videoFile: "Video",
    genericFile: "File",
    empty: "Select or create a question to see how the agent will reply.",
    hint: "This is how the guest will see it in their chat",
  },
  footer: {
    saved: "Saved",
    save: "Save changes",
  },
  errors: {
    load: "Couldn't load the questions.",
    attachNeedsQA: "Write the question and the answer before attaching files.",
    attachNeedsSave: "Save first to be able to attach files.",
    upload: "Couldn't upload the file.",
    deleteFile: "Couldn't delete the file.",
    save: "Couldn't save.",
  },
};
